module.exports = __webpack_public_path__ + "img/leaf_icon.0e5d6cd1.svg";